import './ui.scss';
import { CloseIcon, NotificationErrorIcon, NotificationInfoIcon, NotificationSuccessIcon } from '../icons';

export type NotificationTone = 'info' | 'success' | 'error';

export interface NotificationItem {
  id: number;
  tone: NotificationTone;
  title: string;
  message: string;
}

interface NotificationProps extends NotificationItem {
  onClose: (id: number) => void;
}

/** Возвращает иконку уведомления по его тону. */
function NotificationIcon({ tone }: { tone: NotificationTone }) {
  if (tone === 'success') {
    return <NotificationSuccessIcon width="22px" height="22px" color="currentColor" opacity="1" />;
  }

  if (tone === 'error') {
    return <NotificationErrorIcon width="22px" height="22px" color="currentColor" opacity="1" />;
  }

  return <NotificationInfoIcon width="22px" height="22px" color="currentColor" opacity="1" />;
}

/** UI-компонент toast-уведомления. */
export default function Notification({ id, tone, title, message, onClose }: NotificationProps) {
  return (
    <article className={`notification notification--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <div className="notification__accent" aria-hidden="true" />

      <div className="notification__icon">
        <NotificationIcon tone={tone} />
      </div>

      <div className="notification__content">
        <strong>{title}</strong>
        <p>{message}</p>
      </div>

      <button
        className="notification__close"
        type="button"
        onClick={() => onClose(id)}
        aria-label="Закрыть уведомление"
      >
        <CloseIcon width="16px" height="16px" color="currentColor" opacity="1" />
      </button>
    </article>
  );
}